import React from 'react';
import { Record } from '../types';

interface SummaryCardsProps {
  records: Record[];
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ records }) => {
  const now = new Date();
  const in30 = new Date(now.getTime() + 30 * 864e5);
  const in6m = new Date(now.getFullYear(), now.getMonth() + 6, now.getDate());
  const in12m = new Date(now.getFullYear(), now.getMonth() + 12, now.getDate());

  const inWork = records.filter((r) => r.status === 'In Work').length;
  const ind30 = records.filter((r) => {
    if (!r.induction_date) return false;
    const d = new Date(r.induction_date);
    return d >= now && d <= in30;
  }).length;
  const ind6m = records.filter((r) => {
    if (!r.induction_date) return false;
    const d = new Date(r.induction_date);
    return d >= now && d <= in6m;
  }).length;
  const ind12m = records.filter((r) => {
    if (!r.induction_date) return false;
    const d = new Date(r.induction_date);
    return d >= now && d <= in12m;
  }).length;

  return (
    <section className="summary-cards">
      <div className="summary-card">
        <div className="label">In Work</div>
        <div className="value">{inWork}</div>
      </div>
      <div className="summary-card">
        <div className="label">Induction in 30 Days</div>
        <div className="value">{ind30}</div>
      </div>
      <div className="summary-card">
        <div className="label">Induction in 6 Months</div>
        <div className="value">{ind6m}</div>
      </div>
      <div className="summary-card">
        <div className="label">Induction in 12 Months</div>
        <div className="value">{ind12m}</div>
      </div>
    </section>
  );
};

export default SummaryCards;
